import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx'; // import throttle from 'lodash/throttle';

import * as Sentry from '@sentry/nextjs';
import React, { useCallback, useState
/*, useRef*/
} from 'react';
import featureFlags from '@/config/features';
import { isSmall } from '@/utils/responsive';
import { hasActiveSubscription } from '@/utils/user';
import { createWrappedError } from '@/utils/errors';
import { getWorkbookSourceUrl } from '@/utils/spreadsheets';
import logger from '@/utils/logger';
import { useToast } from '@/hooks/useToast';
import { useAuth } from '@/hooks/useAuth';
import { Loader } from '@/components/loaders/Modal';
import Spreadsheet from '@/components/Spreadsheet';
import { ButtonV2 as Button } from '@/components/Button';
import Footer from '../../Footer';
import SyncFooter from './SyncFooter'; // import { CODES as ERROR_CODES } from '@/components/Spreadsheet/errors';

import DriveSyncConfirmationModal from '../GoogleDriveSync/ConfirmationModal';
import DataEditorHeader from './Header';
import RedirectModal from './RedirectModal';
import ErrorsList from './ErrorsList';
import styles from '../styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ArrowRightIcon = function ArrowRightIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.29286 6.29289C7.90234 6.68342 7.90234 7.31658 8.29286 7.70711L12.5858 12L8.29286 16.2929C7.90234 16.6834 7.90234 17.3166 8.29286 17.7071C8.68339 18.0976 9.31655 18.0976 9.70708 17.7071L15.4142 12L9.70708 6.29289C9.31655 5.90237 8.68339 5.90237 8.29286 6.29289Z",
      fill: "#12131A"
    })
  }));
};

ArrowRightIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const PREFIX = 'components: Editor: modals: Data: Editor:';
const SUPPORT_GOOGLE_DRIVE_SYNC = featureFlags.googleDriveSync;

const DataEditor = _ref => {
  let {
    workbookName,
    workbookId,
    workbookData,
    workbookMeta,
    workbookOrigin,
    workbookUpdatedAt,
    workbookSyncedAt = 0,
    errors = [],
    sheetNames = [],
    canCompleteSyncEnable = true,
    defaultShowErrors = false,
    workbookSyncConfig,
    isLoading,
    containerWidth = 0,
    hasUpdates,
    activeSelection,
    dataSourceOptions,
    onSubscribe,
    onUnSubscribe,
    onEditSelectionsNext,
    onAddNewData = () => null,
    onChange = () => null,
    onSelectionsChange = () => null,
    onSubmit = () => null
  } = _ref;
  const {
    0: isSynchronizing,
    1: setIsSynchronizing
  } = useState(Boolean(workbookSyncConfig));
  const {
    0: isDriveSyncModalVisible,
    1: setIsDriveSyncModalVisible
  } = useState(false);
  const {
    0: isSyncLoading,
    1: setIsSyncLoading
  } = useState(false);
  const {
    0: isEditRedirectModalVisible,
    1: setIsEditRedirectModalVisible
  } = useState(false);
  const {
    0: activeErrorSelection,
    1: setActiveErrorSelection
  } = useState('');
  const {
    0: showErrorsList,
    1: setShowErrorList
  } = useState(defaultShowErrors);
  const {
    addToast: sendNotification
  } = useToast();
  const {
    user
  } = useAuth();
  const showCloseButton = !isSmall(containerWidth);
  const showSyncFooter = Boolean(isSynchronizing && (workbookOrigin === null || workbookOrigin === void 0 ? void 0 : workbookOrigin.originFileId));
  const showSubHeader = containerWidth <= 940;
  const showLoader = isLoading;
  const showDriveSyncControl = SUPPORT_GOOGLE_DRIVE_SYNC && (workbookOrigin === null || workbookOrigin === void 0 ? void 0 : workbookOrigin.origin) === 'google' && !showLoader; // Notify user of catostrophic render error

  const handleRenderError = useCallback(userErr => {
    const wrappedErr = createWrappedError(`${PREFIX} handleRenderError: failed to render`, userErr);
    logger.error(wrappedErr);
    Sentry.captureException(wrappedErr);
    sendNotification({
      type: 'error',
      description: userErr.userMessage || 'Unexpected error during render'
    });
  }, [sendNotification]); // Notify user of any warnings related to their actions
  // NOTE: disabled for spamming & unintended notifications
  // const hasActiveWarningMsg = useRef(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  // const handleSpreadsheetWarning = useCallback(
  //   throttle(
  //     (userErr: UserActionError) => {
  //       let errMessage = userErr.userMessage;
  //       if (userErr.code === ERROR_CODES.uneditableWorkbook) {
  //         errMessage =
  //           'While syncing updates to workbook are discarded, please update source file or disable syncing.';
  //       }
  //       if (userErr.userMessage && !hasActiveWarningMsg.current) {
  //         sendNotification({
  //           type: 'warn',
  //           description: errMessage,
  //         });
  //         setTimeout(() => {
  //           hasActiveWarningMsg.current = false;
  //         }, 4500);
  //         hasActiveWarningMsg.current = true;
  //       }
  //     },
  //     400,
  //     { leading: true }
  //   ),
  //   [sendNotification]
  // );
  // Request to sync workbook to Google Drive updates

  const handleSyncEnable = useCallback(async () => {
    if (!hasActiveSubscription(user)) {
      sendNotification({
        type: 'warning',
        description: 'Please purchase a subscription to activate Google Drive syncing.'
      });
      return;
    }

    if (!canCompleteSyncEnable) {
      sendNotification({
        type: 'info',
        description: 'Please save updates before initiating Google Drive syncing.'
      });
      return;
    }

    setIsSyncLoading(true);

    try {
      await onSubscribe({
        workbookId
      });
      setIsSynchronizing(true);
      sendNotification({
        type: 'success',
        description: 'Now syncing updates from Google Drive, please wait a moment for latest data.'
      });
    } catch (err) {
      setIsSynchronizing(false);
      const wrappedErr = createWrappedError(`${PREFIX} handleSyncEnable: subscribe workbook request failed`, err);
      logger.error(wrappedErr);
      Sentry.captureException(wrappedErr);
      sendNotification({
        type: 'error',
        description: err.userMessage || 'Failed to sync workbook, please try again'
      });
    } finally {
      setIsSyncLoading(false);
    }
  }, [user, setIsSyncLoading, setIsSynchronizing, onSubscribe, sendNotification, workbookId, canCompleteSyncEnable]); // Disable all sync updates to a workbook

  const handleSyncDisable = useCallback(async () => {
    setIsSynchronizing(false); // Assume successful

    setIsSyncLoading(true);

    try {
      await onUnSubscribe({
        workbookId
      });
    } catch (err) {
      const wrappedErr = createWrappedError(`${PREFIX} handleSyncDisable: unsubscribe workbook request failed`, err);
      logger.error(wrappedErr);
      Sentry.captureException(wrappedErr);
      sendNotification({
        type: 'error',
        description: err.userMessage || 'Failed to unsync workbook, please try again'
      });
      setIsSynchronizing(true);
    } finally {
      setIsSyncLoading(false);
    }
  }, [onUnSubscribe, sendNotification, workbookId]); // Handle toggling on/off of workbook syncing

  const handleSyncStateChange = useCallback(async (_, checked) => {
    if (isSyncLoading) return; // Confirm user wants to abandon workbook
    // changes before initiating a sync/subscription

    if (checked && workbookSyncedAt < workbookUpdatedAt) {
      setIsDriveSyncModalVisible(true);
      return;
    }

    if (checked) {
      handleSyncEnable();
    } else {
      handleSyncDisable();
    }
  }, [setIsDriveSyncModalVisible, workbookSyncedAt, workbookUpdatedAt, handleSyncDisable, handleSyncEnable, isSyncLoading]);

  const handleConfirmRedirect = () => {
    const workbookSourceUrl = getWorkbookSourceUrl({
      originFileId: (workbookOrigin === null || workbookOrigin === void 0 ? void 0 : workbookOrigin.originFileId) || '',
      originFileType: (workbookOrigin === null || workbookOrigin === void 0 ? void 0 : workbookOrigin.originFileType) || ''
    });

    if (workbookSourceUrl) {
      window.open(workbookSourceUrl, '_blank');
    }

    setIsEditRedirectModalVisible(false);
  };

  const handleErrorSelect = error => {
    setActiveErrorSelection(error.cellRef);
  };

  const handleErrorListActivate = () => {
    setShowErrorList(prev => !prev);
    setActiveErrorSelection('');
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(DataEditorHeader, {
      workbookName: workbookName || 'Data',
      originFileType: (workbookOrigin === null || workbookOrigin === void 0 ? void 0 : workbookOrigin.originFileType) || '',
      isLoading: isLoading,
      isSyncLoading: isSyncLoading,
      isSynchronizing: isSynchronizing,
      showDriveSyncControl: showDriveSyncControl,
      showSubHeader: showSubHeader,
      errors: errors,
      dataSourceOptions: dataSourceOptions,
      onAddNewData: onAddNewData,
      onSyncStateChange: handleSyncStateChange,
      onErrorsListActivate: handleErrorListActivate
    }), /*#__PURE__*/_jsx("div", {
      className: clsx(styles.main, showLoader ? styles['main--loading'] : '', !showSyncFooter && isSynchronizing ? styles['main--noFooter'] : ''),
      children: showLoader ? /*#__PURE__*/_jsx(Loader, {}) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ErrorsList, {
          isVisible: showErrorsList && Boolean(errors.length),
          errors: errors,
          onSelect: handleErrorSelect,
          sheetNames: sheetNames,
          onClose: () => setShowErrorList(false)
        }), /*#__PURE__*/_jsx(Spreadsheet, {
          data: workbookData,
          meta: workbookMeta,
          editable: !isSynchronizing,
          syncedAt: isSynchronizing ? workbookSyncedAt : 0,
          onChange: onChange,
          onSelect: selection => {
            onSelectionsChange(selection);
          },
          onError: handleRenderError // onWarn={handleSpreadsheetWarning}
          ,
          activeSelection: activeErrorSelection || activeSelection,
          workbookOrigin: workbookOrigin
        })]
      })
    }), showSyncFooter ? /*#__PURE__*/_jsx(SyncFooter, {
      primaryCta: "Edit Source",
      secondaryCta: "Close",
      onPrimaryClick: () => setIsEditRedirectModalVisible(true)
    }) : /*#__PURE__*/_jsx(_Fragment, {}), !isSynchronizing ? /*#__PURE__*/_jsx(Footer, {
      showCloseButton: showCloseButton,
      containerWidth: containerWidth,
      className: styles.footer,
      actions: typeof onEditSelectionsNext === 'function' ? /*#__PURE__*/_jsxs("div", {
        className: styles.footerActions,
        children: [/*#__PURE__*/_jsx(Button, {
          type: "button",
          variant: "link",
          disabled: !hasUpdates || isLoading || isSynchronizing,
          onClick: onSubmit,
          children: "Save Data"
        }), /*#__PURE__*/_jsx(Button, {
          type: "button",
          variant: "primary",
          disabled: isLoading || isSynchronizing,
          onClick: onEditSelectionsNext,
          rightIcon: /*#__PURE__*/_jsx(ArrowRightIcon, {}),
          children: "Selections"
        })]
      }) : /*#__PURE__*/_jsx(Button, {
        type: "button",
        variant: "primary",
        disabled: !hasUpdates || isLoading || isSynchronizing,
        onClick: onSubmit,
        children: "Save Data"
      }),
      errors: errors,
      onErrorsClick: handleErrorListActivate
    }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx(DriveSyncConfirmationModal, {
      isVisible: isDriveSyncModalVisible,
      onClose: () => setIsDriveSyncModalVisible(false),
      onConfirm: () => {
        handleSyncEnable();
        setIsDriveSyncModalVisible(false);
      }
    }), /*#__PURE__*/_jsx(RedirectModal, {
      isVisible: isEditRedirectModalVisible,
      onClose: () => setIsEditRedirectModalVisible(false),
      onConfirm: handleConfirmRedirect
    })]
  });
};

export default DataEditor;